/**
 * Human-readable timestamp for Google Sheets / Apps Script payloads.
 *
 * Returns a string like "October 23, 2025, 3:45:30 PM" in the browser's
 * local timezone — designed to drop straight into a Google Sheet column.
 */
export function getFormattedTimestamp(): string {
  const now = new Date();
  return now.toLocaleString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
  });
}
